import {
  createSelectorHooks,
  ZustandHookSelectors
} from 'auto-zustand-selectors-hook'
import create from 'zustand'

interface Order {
  orderId: string
  isModalOpen: boolean
  setModalOpen: (open: boolean) => void
  setOrderId: (orderId: string) => void
}

const useStoreBase = create<Order>()((set) => ({
  orderId: '',
  isModalOpen: false,
  setModalOpen: (isModalOpen: boolean) => set(() => ({ isModalOpen })),
  setOrderId: (orderId: string) => set(() => ({ orderId }))
}))

export const useFutureDeliveryModalStore = createSelectorHooks(
  useStoreBase
) as typeof useStoreBase & ZustandHookSelectors<Order>
